export const HELP_CENTER_RELEASE_NOTE_API_PATH = 'HelpCenter/release-notes';
export const HELP_CENTER_TRAINING_MATERIAL_API_PATH =
  'HelpCenter/quick-reference-cards';
